import { Diamond, FavoriteBorder, OpenInNew } from "@mui/icons-material";

import AvatorOne from "../assets/img1.avif";
import { styled } from "@mui/material/styles";
const {
  Box,
  Paper,
  IconButton,
  Tooltip,
  tooltipClasses,
} = require("@mui/material");

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#04111D",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#04111D",
    padding: "15px",
    color: "white",
    fontWeight: "bold",
    fontSize: "14px",
  },
  [`& .${tooltipClasses.tooltipPlacementTop}`]: {
    margin: "-8px 0", // Adjust the margin as needed for proper positioning
  },
}));

const ImageViewer = () => {
  return (
    <Box sx={{ px: 2 }}>
      <Paper
        sx={{
          border: "1px solid lightgray",
          display: "flex",
          flexDirection: "column",
          borderRadius: "12px",
        }}
        elevation={0}
      >
        <Box sx={{ display: "flex" }}>
          <Box sx={{ width: "10%", m: 1 }}>
            <Diamond sx={{ color: "black" }} />
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "right",
              width: "90%",
              m: 1,
              alignItems: "center",
            }}
          >
            <Box>
              <BootstrapTooltip title='View original media' placement='top'>
                <IconButton>
                  <OpenInNew sx={{ color: "black", fontWeight: "bold" }} />
                </IconButton>
              </BootstrapTooltip>
            </Box>
            <Box>3</Box>
            <Box>
              <BootstrapTooltip title='Favorite' placement='top'>
                <IconButton>
                  <FavoriteBorder sx={{ color: "black", fontWeight: "bold" }} />
                </IconButton>
              </BootstrapTooltip>
            </Box>
          </Box>
        </Box>
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
          <img src={AvatorOne} alt='Milady 1780' width={"80%"} />
        </Box>
      </Paper>
    </Box>
  );
};

export default ImageViewer;
